import { all, fork } from "redux-saga/effects";
import AuthSaga from "./authSaga";
import OtpSaga from "./otpSaga";
import ProfileDetailsSaga from "./profileDetailsSaga";
import PaymentSaga from "./paymentSaga";
import TncSaga from "./tncSaga";
import TransactionSaga from "./transactionSaga";
import SuccessSaga from "./successSaga";
import UploadDocumentSaga from "./uploadDocumentSaga";

export default function* rootSaga() {
  yield all([
    fork(AuthSaga),
    fork(TransactionSaga),
    fork(PaymentSaga),
    fork(TncSaga),
    fork(ProfileDetailsSaga),
    fork(OtpSaga),
    fork(SuccessSaga),
    fork(UploadDocumentSaga),
  ]);
}
